import styles from './RequiredMarker.module.css';

export const RequiredMarker = () => <span className={styles.wrapper}>*</span>;
